export const LAYOUT = {
  input: {
    search: "col-xl-2 col-lg-3 col-md-6",
    medium: "col-xl-2 col-lg-3 col-md-6",
    small: "col-xl-2 col-lg-3 col-md-6",
    minSearch: "col-6",
    minMedium: "col-6",
    minSmall: "col-6",
  },

  gap: {
    horizontal: 16,
    vertical: 16,
    filterToTable: 24,
    actionButton: 16,
  },

  actionOrder: [
    "import",
    "export",
    "create",
    "reload",
  ],

  columns: {
    small: 50,
    medium: 130,
    large: 150,
    xlarge: 200,
  }
};